<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    class="py-4"
    @submit.prevent="submit"
    @keypress.enter="submit"
  >
    <v-row justify="center">
      <v-col cols="12" md="6">
        <t-country-select v-model="user.form.model.address.country" />
      </v-col>
      <v-col v-if="brazilianAddress" cols="12" md="6">
        <t-cep-input v-model="user.form.model.address.zipcode" @cep="handleZipcodeFilling" />
      </v-col>
      <v-col v-else cols="12" md="6">
        <t-text-input
          v-model="user.form.model.address.zipcode"
          label="CEP (Código Postal)"
          required
          hide-details="auto"
        />
      </v-col>

      <v-col cols="12" md="4">
        <t-text-input
          v-model="user.form.model.address.neighborhood"
          label="Bairro"
          required
          hide-details="auto"
          :disabled="!user.form.model.address.zipcode && brazilianAddress"
        />
      </v-col>

      <v-col cols="12" md="4">
        <t-text-input
          v-model="user.form.model.address.state"
          label="Estado"
          hide-details="auto"
          required
          :disabled="brazilianAddress"
        />
      </v-col>

      <v-col cols="12" md="4">
        <t-text-input
          v-model="user.form.model.address.city"
          label="Cidade"
          hide-details="auto"
          required
          :disabled="brazilianAddress"
        />
      </v-col>

      <v-col cols="12" md="8">
        <t-text-input
          v-model="user.form.model.address.street"
          label="Endereço"
          required
          hide-details="auto"
          :disabled="!user.form.model.address.zipcode && brazilianAddress"
        />
      </v-col>

      <v-col cols="12" md="4">
        <t-text-input
          v-model="user.form.model.address.number"
          label="Número"
          required
          hide-details="auto"
          :maxlength="10"
        />
      </v-col>

      <v-col cols="12">
        <t-text-input v-model="user.form.model.address.complement" label="Complemento (opcional)" hide-details="auto" />
      </v-col>

      <v-col cols="12" class="pt-0">
        <v-checkbox v-model="policy" hide-details>
          <template #label>
            <div>
              Aceito e concordo com os
              <v-tooltip bottom>
                <template #activator="{ props }">
                  <a
                    target="_blank"
                    href="termos"
                    v-bind="props"
                    @click.stop
                  > Termos de Uso </a>
                </template>
                Abre em nova página
              </v-tooltip>
            </div>
          </template>
        </v-checkbox>
      </v-col>

      <v-col cols="12" class="d-flex justify-center">
        <t-btn
          color="success"
          block
          type="submit"
          class="heading--text"
          large
          :loading="loader.loading('button')"
          :disabled="!valid || !policy"
        >
          Avançar
        </t-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup lang="ts">
import { ref, useTemplateRef, type Ref, computed } from "vue";
import type Address from "@/types/Address";
import TBtn from "@/components/core/TBtn.vue";
import TTextInput from "@/components/core/TTextInput.vue";
import TCepInput from "@/components/core/TCepInput.vue";
import TCountrySelect from "@/components/core/TCountrySelect.vue";
import { useUserStore } from "@/stores/user";
import { useLoader } from "@/stores/loader";

defineOptions({
  name: "FormAddress",
});

const user = useUserStore();
const loader = useLoader();

const form = useTemplateRef<{ validate: () => boolean }>("form");

const emit = defineEmits<{
  submit: [];
}>();

const brazilianAddress = computed<boolean>(() => user.form.model.address.country === "Brazil");

const valid: Ref<boolean> = ref(true);
const policy: Ref<boolean> = ref(false);

function submit(): void {
  if (!form.value?.validate()) return;

  emit("submit");
}
function handleZipcodeFilling(addressData: Address): void {
  user.form.model.address = {
    ...user.form.model.address,
    ...addressData,
  };
}
</script>
